import Router from 'vue-router';
import ProjectUsageForm from './view/ProjectUsageForm';
import HowDoYouUseProjectForm from './view/HowDoYouUseProjectForm';
import WorkEnvironmentForm from './view/WorkEnvironmentForm';

const userQuestionnaireModalRoute = {
    PROJECT_USAGE: 'project-usage',
    HOW_PROJECT_USE: 'how-use',
    WORK_ENVIRONMENT: 'work-environment',
};

export { userQuestionnaireModalRoute };

const userQuestionnaireModalRouter = new Router({
    mode: 'abstract',
    routes: [
        {
            path: '/project-usage',
            name: userQuestionnaireModalRoute.PROJECT_USAGE,
            component: ProjectUsageForm,
            props: true,
        },
        {
            path: '/how-project-use',
            name: userQuestionnaireModalRoute.HOW_PROJECT_USE,
            component: HowDoYouUseProjectForm,
            props: true,
        },
        {
            path: '/work-environment',
            name: userQuestionnaireModalRoute.WORK_ENVIRONMENT,
            component: WorkEnvironmentForm,
            props: true,
        },
    ],
});

export { userQuestionnaireModalRouter };
